import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import {searchSuppliers, showDeleteSupplierModal} from "./actions";
import ListView from "../common/ListView";
import DeleteSupplierFormModal from "./DeleteSupplierFormModal";
import AddressDisplay from "../common/AddressDisplay";

const SupplierContact = ({contact}) => {
  if (!contact) return <span className="contact-missing">N/A</span>;
  const {firstName, lastName, phone, email} = contact;
  if (!firstName && !lastName && !phone && !email) return <span className="contact-missing">N/A</span>;
  return (
    <div className="contact">
      {(firstName || lastName) && <div className="contact-name">{firstName} {lastName}</div>}
      {phone && <div className="contact-phone">{phone}</div>}
      {email && <div className="contact-email">{email}</div>}
    </div>
  );
};

SupplierContact.propTypes = {
  contact: PropTypes.object
};

class SuppliersPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    dispensaryId: PropTypes.string,
    search: PropTypes.object.isRequired,
    /* actions */
    searchSuppliers: PropTypes.func.isRequired,
    showDeleteSupplierModal: PropTypes.func.isRequired,
    deleteSupplierModalVisible: PropTypes.bool,
  };

  static defaultProps = {
    dispensaryId: null
  };

  render() {
    const {
      dispensaryId, history, searchSuppliers, deleteSupplierModalVisible,
      search: {searching, pagination, filters, sorter, results, searchFilter},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        className: 'truncated-column',
        fixed: 'left',
        width: 200,
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true,
        className: 'truncated-column',
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        render: address => <AddressDisplay address={address}/>
      },
      {
        title: 'Contact',
        dataIndex: 'contact',
        key: 'contact',
        render: contact => <SupplierContact contact={contact}/>
      },
      {
        title: 'Grow Op',
        dataIndex: 'growOpName',
        key: 'growOpName'
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 110,
        render: (_, supplier) => {
          return (
            <React.Fragment>
              <Link to={`/supplier/update/${encodeURIComponent(supplier.supplierId)}`}>Edit</Link>
              {' | '}
              <a onClick={() => this.props.showDeleteSupplierModal(supplier)}>Delete</a>
            </React.Fragment>
          );
        },
      }
    ];
    return (
      <React.Fragment>
        {deleteSupplierModalVisible && <DeleteSupplierFormModal onDelete={() => this.listView.refresh()}/>}
        <ListView
          ref={ref => this.listView = ref}
          title="Suppliers"
          loading={searching}
          columns={columns}
          dataSourceProvider={searchSuppliers}
          dataSource={results}
          pagination={pagination}
          filters={filters}
          sorter={sorter}
          searchFilter={searchFilter}
          dispensaryId={dispensaryId}
          rowKey="supplierId"
          onAdd={() => history.push('/supplier/add')}
          scroll={{x: 1000}}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.supplier.gettingSuppliers,
  dispensaryId: state.dispensary.selectedDispensaryId,
  search: state.supplier.search,
  deleteSupplierModalVisible: state.supplier.deleteSupplierModalVisible,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchSuppliers,
  showDeleteSupplierModal,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(SuppliersPage);



// WEBPACK FOOTER //
// ./src/Supplier/SuppliersPage.js